import Link from 'next/link';
import { ReactNode } from 'react';
import styled from 'styled-components';

export type VaxNavigationProps = {
	children?: ReactNode;
};

const StyledNavigation = styled.div`
	a {
		color: white;
		text-decoration: none;
		padding: 7px;
	}
	a:hover {
		text-decoration: underline;
	}
`;

const VaxNavigation = (_props: VaxNavigationProps) => {
	return (
		<StyledNavigation
			className='d-flex w-100 justify-content-around rounded'
			style={{ background: 'var(--dunkelblau)', color: 'white' }}
		>
			<Link href={'/impfschaden/studien'}>
				<div>Studien und Fakten</div>
			</Link>
			<Link href={'/impfschaden'}>
				<div>Geschädigte Zeugen</div>
			</Link>
			<Link href={'/impfschaden/news'}>
				<div>Neuigkeiten</div>
			</Link>
			<Link href={'/impfschaden/verlinkt'}>
				<div>Verlinkt</div>
			</Link>
		</StyledNavigation>
	);
};
export { VaxNavigation };
